import { ThemeProvider } from "@mui/material/styles";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { createLocalizedTheme } from "../styles/mui-theme";
import { RootState } from "../types";

interface DynamicThemeProviderProps {
  children: React.ReactNode;
}

export const DynamicThemeProvider: React.FC<DynamicThemeProviderProps> = ({
  children,
}) => {
  const account = useSelector((state: RootState) => state.account);

  const theme = useMemo(() => {
    // Wait for account to load before applying user's language preference
    if (!account.isLoading && account.language) {
      return createLocalizedTheme(account.language);
    }
    // Default to English while loading
    return createLocalizedTheme("en");
  }, [account.isLoading, account.language]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
